export default class Settings {
    google_client_id!: string
    line_client_id!: string
    mapbox_access_token!: string
    static unmarshal(json: any): Settings | undefined {
        if (!json) {
            return undefined
        }
        var settings = Object.assign(new Settings(), json)
        return settings
    }
}
